<template>
  <div class="absolute inset-y-0 right-0 mr-2 flex flex-row items-center">
    <span
      class="grid size-5 place-items-center rounded text-white"
      :class="{
        'bg-green-500': status === 'valid',
        'bg-red-600': status === 'invalid'
      }"
    >
      <FontAwesomeIcon
        :icon="['fal', status === 'valid' ? 'check' : 'times']"
      />
    </span>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/**
 * Green tick or red cross at the right of a `fm-form-input`, for the inputs
 * that check an identifier as it is typed (BBSW-11615).
 */
export default {
  name: 'BaseShowEditStatusBadge',
  components: { FontAwesomeIcon },
  props: {
    status: {
      type: String,
      required: true,
      validator: (value) => ['valid', 'invalid'].includes(value)
    }
  }
}
</script>
